(function ($) {
  $(document).ready(function ($) {
    console.log('theme.js initialization');

    var inHeight = window.innerHeight / 100;
    var inHeight2 = window.innerHeight / 100;
    Splitting();

    document.documentElement.style.setProperty('--vh', inHeight + 'px');
    document.documentElement.style.setProperty('--vhm', inHeight2 + 'px');

    $(window).resize(function (event) {
      inHeight2 = window.innerHeight / 100;
      document.documentElement.style.setProperty('--vhm', inHeight2 + 'px');
    });

    var isMobile = window.matchMedia(
      'only screen and (max-width: 949px)'
    ).matches;

    /*****************************************************************
      Touch fix for devices to mimick hover effects
    ******************************************************************/
    $('*')
      .on('touchstart', function () {
        $(this).trigger('hover');
      })
      .on('touchend', function () {
        $(this).trigger('hover');
      });

    /*****************************************************************
      Scroll from top add class to the body for the nav
    ******************************************************************/
    $(window).scroll(function () {
      if ($(window).scrollTop() > 50) {
        $('body').addClass('scrolled');
      } else {
        $('body').removeClass('scrolled');
      }
    });

    /*****************************************************************
      Animation Library / Area.
      GSAP + GSAP ScrollTrigger
    ******************************************************************/
    gsap.registerPlugin(ScrollTrigger);

    // GSAP Custom Parallax
    gsap.utils.toArray('[data-gsap]').forEach((el) => {
      const obj = eval('(' + el.dataset.gsap + ')');
      // Scroll Options
      const scrollProps = {
        scrollTrigger: {
          start: 'top bottom',
          end: 'bottom top',
          trigger: el,
          scrub: 0.25, // Sets a 0.5 second delay, true is default for scrub
          //markers: true,
        },
      };
      // Add values to object from element data attribute
      Object.assign(scrollProps, obj);

      gsap.to(el, scrollProps);
    });

    // Scroll into view section animations
    gsap.utils.toArray('.fade-in-up').forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: 'top 85%',
          end: 'bottom top',
          trigger: el,
          toggleClass: 'show',
          //markers: true,
        },
      });
    });

    gsap.utils.toArray('.fade-in-up-once').forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: 'top 85%',
          end: 'bottom top',
          trigger: el,
          toggleClass: 'show',
          once: true,
          // onEnter: ({progress, direction, isActive}) => {
          //   if (isActive) {
          //     $(el).addClass("show");
          //   }
          // },
          //markers: true,
        },
      });
    });

    gsap.utils.toArray('.fade-in').forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: 'top 80%',
          end: 'bottom top',
          trigger: el,
          toggleClass: 'show',
          //markers: true,
        },
      });
    });

    gsap.utils.toArray('.fade-in-once').forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: 'top 85%',
          end: 'bottom top',
          trigger: el,
          toggleClass: 'show',
          once: true,
          //markers: true,
        },
      });
    });

    gsap.utils.toArray('.line-reveal').forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: 'top 85%',
          end: 'bottom top',
          trigger: el,
          toggleClass: 'show',
          once: true,
          //markers: true,
        },
      });
    });

    /*****************************************************************
     * Scroll Down to next section quick script
     *****************************************************************/
    if ($('.scroll-down').length) {
      $('.scroll-down').click(function (e) {
        e.preventDefault();
        var nextSection = $(this).parent().closest('.shopify-section').next();

        $('html, body').animate(
          {
            scrollTop: nextSection.offset().top + 1,
          },
          800,
          function () {
            // window.location.hash = hash;
          }
        );
      });
    }

    /*****************************************************************
      Klaviyo form integration (footer)
    *****************************************************************/
    function KlaviyoSubscribe(listID, email, source) {
      var subscribed = false;
      $.ajax({
        type: 'POST',
        url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
        data: {
          g: listID,
          $fields: '$source, $consent, $email, Accepts Marketing',
          email: email,
          $consent: ['email'],
          //pass in additional fields
          //$fields: "$source, $first_name, $last_name",
          AcceptsMarketing: true,
          $source: source,
        },
        contentType: 'application/x-www-form-urlencoded',
        error: function (err) {
          console.log('Could not connect to Klaviyo.');
          console.log(err);
        },
        success: function (res) {
          console.log('success');
          console.log(res);
          subscribed = true;

          if (res.data.is_subscribed == false) {
            $('#footer-klaviyo').remove();
            $('#footer-klaviyo-message p').text(klaviyoMsg);
          }

          if (res.data.is_subscribed == true) {
            klaviyoMsg = 'That email is already subscribed to our list!';
            $('#footer-klaviyo').remove();
            $('#footer-klaviyo-message p').text(klaviyoMsg);
          }
        },
        async: false,
      });
      return subscribed;
    }

    $('#subscribe-to-newsletter').click(function (event) {
      event.preventDefault();
      const listID = $('#footer-klaviyo').data('klaviyoid');
      const email = $('#footer-subscribe').val();
      const source =
        'Nocsprovisions.com - General Newsletter singup, from footer';
      console.log(listID, email, source);
      if (email != '') {
        KlaviyoSubscribe(listID, email, source);
      } else {
        // do nothing
      }
    });
    /*****************************************************************
      END Klaviyo form integration
    *****************************************************************/

    /*****************************************************************
      Carousels Used site-wide
    *****************************************************************/

    // Featured Prodcuts Slider
    // ---
    var $featuredProducts = $('.featured-products-slider .owl-carousel');
    $featuredProducts.each(function (index, el) {
      $(el).owlCarousel({
        lazyLoad: true,
        autoWidth: true,
        items: 1,
        nav: false,
        dots: false,
        responsive: {
          767: {
            items: 3,
          },
        },
      });
    });
    // ---
    // END Featured Prodcuts Slider

    // Imagery Slider
    // ---
    var $imagerySlider = $('.imagery-slider .owl-carousel');
    $imagerySlider.each(function (index, el) {
      $(el).owlCarousel({
        autoWidth: true,
        loop: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 6500,
        lazyLoad: true,
      });
    });
    // ---
    // END Imagery Slider

    /*****************************************************************
      END – Carousels Used site-wide
    *****************************************************************/

    /*****************************************************************
      Regional / locale selector dropdown in the footer
    *****************************************************************/
    // Get the current URL
    var currentURL = new URL(window.location.href);
    console.log(currentURL);
    if (currentURL.href == 'http://127.0.0.1:9292/') {
      currentURL = new URL('https://www.nocsprovisions.com/');
    }

    $('.region-wrap').click(function (event) {
      var submenu = $(this).children('ul');
      if ($(submenu).hasClass('show')) {
        console.log('inside truthy');
        $(submenu).removeClass('show');
      } else {
        console.log('inside falsey');
        $(submenu).addClass('show');
      }
    });

    console.log(currentURL);
    // Loop through each <li> element to find the matching URL
    $('.region-wrap ul li').each(function () {
      var listItem = $(this);
      var anchor = listItem.find('a');
      var anchorURL = anchor.attr('href').toString();

      // Check if the URL matches
      if (currentURL.href.includes(anchorURL)) {
        // Extract the region and flag spans
        var regionSpan = listItem.find('.region').clone();
        var flagSpan = listItem.find('.flag').clone();

        // Append them to the current-region div
        $('.current-region').append(regionSpan).append(flagSpan);

        // Remove the original <li> element
        listItem.remove();

        var regionHeight = $('.region-wrap').outerHeight(true);
        var adjustedRegionHeight = regionHeight - 8;
        $('.region-wrap ul').css('top', adjustedRegionHeight);

        // Exit the loop
        return false;
      } else {
        console.log('inside falsey for .region-wrap');
      }
    });

    /*****************************************************************
      END – Regional / locale selector dropdown in the footer
    *****************************************************************/
  }); // end .ready()
})(jQuery);
